import { createContext, useContext, useEffect } from 'react';

type SidebarMenuValue = {
  open: () => void;
  isCollapsed: boolean;
  registerCustomTrigger: () => () => void;
};

const SidebarMenuContext = createContext<SidebarMenuValue>({
  open: () => {},
  isCollapsed: false,
  registerCustomTrigger: () => () => {},
});

export { SidebarMenuContext };

type Options = {
  customTrigger?: boolean;
};

export function useSidebarMenu({ customTrigger = false }: Options = {}) {
  const { open, isCollapsed, registerCustomTrigger } = useContext(SidebarMenuContext);
  useEffect(() => {
    if (!customTrigger) return;
    return registerCustomTrigger();
  }, [customTrigger, registerCustomTrigger]);
  return { open, isCollapsed };
}
